import React from 'react'
import { Alert, Space, Spin, Typography } from 'antd'
import { AutoCheckState } from './useAutoCheck'

const { Text } = Typography

type Props = {
  state: AutoCheckState
}

export const AutoCheckBanner = ({ state }: Props) => {
  if (state.kind === 'loading') {
    return (
      <Space>
        <Spin size="small" />
        <Text type="secondary">Comparing document with CRM fields...</Text>
      </Space>
    )
  }
  if (state.kind === 'error') {
    return null
  }
  if (state.kind === 'ready') {
    if (!state.comparison.isDocument) {
      return (
        <Alert
          type="error"
          showIcon
          message="Not a plausible ID document or could not read it."
        />
      )
    }
    if (state.comparison.verdictOk) {
      return (
        <Alert
          type="success"
          showIcon
          message="Identity document looks valid; all fields match CRM."
        />
      )
    }
    return (
      <Alert
        type="warning"
        showIcon
        message="Document looks like ID, but some fields differ from CRM."
      />
    )
  }
  return null
}
